import React, { useEffect } from 'react';
import './Otp-block.css';

const OtpBlock = ({ handleChange, inputFocus, otpValues }) => {
  useEffect(() => {
    const handlePaste = (ev) => {
      if (ev.target.localName !== 'input') return;
      ev.preventDefault();
      let paste = (ev.clipboardData || window.clipboardData).getData('text');
      paste = paste.replace(/[^0-9]/g, '');
      const inputs = document.querySelectorAll('.otpInput');
      if (paste.length !== inputs.length) return;
  
      inputs.forEach((input, index) => {
        input.focus();
        input.value = paste[index];
  
        const syntheticEvent = {
          target: {
            value: paste[index],
          },
        };
  
        handleChange(index, syntheticEvent);
      });
    };
  
    document.addEventListener('paste', handlePaste);
  
    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, [handleChange]);
  

  return (
    <form>
      <div className="otpContainer col-12">
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <input
            type="text"
            required
            key={index}
            name={`otp${index}`}
            autoComplete="off"
            className="otpInput"
            value={otpValues[`otp${index}`]}
            onChange={(e) => handleChange(index, e)}
            tabIndex={index}
            maxLength="1"
            onKeyUp={(e) => inputFocus(e)}
          />
        ))}
      </div>
    </form>
  )
};

export default OtpBlock;
